import { render } from "./TextVotesBox.vue?vue&type=template&id=7bdd2fd2"
import script from "./TextVotesBox.vue?vue&type=script&lang=js"
export * from "./TextVotesBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__